import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  max-width: 1529px !important;
  min-width: 633px !important;
`

export const MainContainer = styled.div`
  gap: ${props => props.theme.spacing.sp32};
  display: grid;
  grid-template-columns: 65% calc(35% - ${props => props.theme.spacing.sp32});

  @media screen and (max-width: 1163px) {
    grid-template-columns: 100%;
  }
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const NavRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NavContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const HeaderOptions = styled.div`
  display: flex;
  justify-content: space-between;
`

export const HeaderOptionsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const AcceptOrRejectContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const DetailCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ChipsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const DatesRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const SummaryCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const InfoBlocks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => props.theme.spacing.sp16};
`

export const LineItem = styled.div`
  display: flex;
  flex-direction: column;
  border: ${props => props.theme.stroke.emphasis} solid ${props => props.theme.colors.info.surface};
  border-radius: ${props => props.theme.primitives.radius.radius4};
`

export const LineItemBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
`

export const ProductRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ReasonBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  background-color: ${props => props.theme.colors.info.surface};
  padding: 6px ${props => props.theme.spacing.sp16};
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
`

export const TimelineContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const CommentRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const CommentInput = styled.div`
  flex: 1;
`

export const TimelineEvents = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const TimelineEvent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp8};
`

export const TimelineEventText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
